(function () {
    'use strict';

    angular
        .module('sempraWebapp')
        .controller('dailyEuroKeyReportController', dailyEuroKeyReportController);

    /** @ngInject */
    function dailyEuroKeyReportController ($scope, $translate, reportExportUtil, exportToCsv, DailyEuroKeyReportViewModel, dispatcher, ActionTypesEnum) {
        var vm = this;

        vm.report = new DailyEuroKeyReportViewModel();
        vm.exportToCsv = exportCsv;

        init();

        function init () {
            $scope.$on('$destroy', destroy);
            dispatcher.dispatch({
                type: ActionTypesEnum.SHOW_LOADER
              });
        }

        function destroy () {
            vm.report.destroy();
        }

        function exportCsv () {
            var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
                $translate.instant('DATE'),
                vm.report.chart.data,
                reportExportUtil.ValueFormattersEnum.DATE,
                reportExportUtil.ValueFormattersEnum.NUMBER);

            exportToCsv.export(jsonArrayForExport,
                $translate.instant('EUROKEY_BY_DATE_REPORT'),
                true);
        }

    }
})();
